import { render, staticRenderFns } from "./CatalogReservationConfigAutomatic.vue.html?vue&type=template&id=58336bea&"
import script from "./CatalogReservationConfigAutomatic.component.js?vue&type=script&lang=vueJs&"
export * from "./CatalogReservationConfigAutomatic.component.js?vue&type=script&lang=vueJs&"
import style0 from "./CatalogReservationConfigAutomatic.scss?vue&type=style&index=0&prod&lang=vueScss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports